import Init from '../../../extendable/Init';
import nTabs from '../../../resources/js/core/Tabs/Tabs';
import './News.scss';
import ArticleBox from '../../../components/ArticleBox/ArticleBox';

const News = () => {
    nTabs('news');
};

Init(News);
